import styled from 'styled-components';

export const Container = styled.div`
  padding: 2.4rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  background-color: #1f1e25;
  border-radius: 2rem;
`;

export const Label = styled.p`
  color: #eae8ed;
  font-size: 2rem;
  line-height: 2.6rem;
  font-weight: 600;
  margin-bottom: 1.2rem;
`;
